<template>
  <ul class="accordion">
    <li v-for="(item, i) in accordionList" :key="item.id" class="accordion__list-item">
      <component
        :is="'VAccordionItem' + type"
        :class="openItemId === item.id ? 'accordion__item--open' : ''"
        :is-open="openItemId === item.id"
        :is-coef-view="isCoefView"
        :item="item"
        :count="i + 1"
        @delete="$emit('delete', item)"
        @open="$emit('open', item)" />
    </li>
  </ul>

  <slot />
</template>

<script>
import VAccordionItemPosition from '@/components/ui/accordion/Decorators/Position/VAccordionItemPosition'
import VAccordionItemCategory from '@/components/ui/accordion/Decorators/Category/VAccordionItemCategory'

export default {
  components: {
    VAccordionItemPosition,
    VAccordionItemCategory,
  },
  props: {
    openItemId: {
      type: Number,
      required: false,
    },
    accordionList: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      required: false,
    },
    isCoefView: {
      type: Boolean,
      required: false,
    },
  },
  emits: ['add', 'create', 'delete', 'open'],
}
</script>
